import { render, staticRenderFns } from "./AssignQuestionSimple.vue?vue&type=template&id=6af3a3a6"
import script from "./AssignQuestionSimple.vue?vue&type=script&lang=js"
export * from "./AssignQuestionSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports